import { Dispatch, SetStateAction, useCallback } from 'react'
import { FirebaseDocRefType } from 'firebase/index'
import { StockUnionType } from 'types/stock'
import { getUpdateSchedulesFunction } from 'components/Templates/product/default/ProductEditDefaultTemplate'
import { getInitialStoreDefaultSchedule } from 'reducks/storeDefault/operations'
import { StoreDefaultScheduleType } from 'types/storeDefault'

const useAddDefaultSchedule = (
  storeDefaultBreadRef: FirebaseDocRefType,
  setDailySchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>
): ((type: StockUnionType) => void) => {
  return useCallback(
    (type: StockUnionType) => {
      const update = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!update) return
      update((prevState) => {
        const defaultSchedule = prevState[0] ?? undefined
        const scheduleRef = storeDefaultBreadRef.parent.parent?.collection('store_default_schedules').doc()
        if (!scheduleRef) return prevState
        return [...prevState, getInitialStoreDefaultSchedule(storeDefaultBreadRef, scheduleRef, type, defaultSchedule)]
      })
    },
    [setDailySchedules, setPreorderSchedules, storeDefaultBreadRef]
  )
}

export default useAddDefaultSchedule
